import PIXI from 'pixi.js/src';
import config from './../config/config';
import router from './../router/router';
import GameStore from './../stores/GameStore';
import renderHelper from './../helpers/render';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const preloaderView = {
  /**
   * Sets up the view
   * @returns {undefined} undefined
   */
  init() {
    this.preloaderContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.preloaderContainer);

    this.loadingText = new PIXI.Text('LOADING',
      {
        font: '24px ' + config.fontName,
        fill: config.whiteColor,
      }
    );

    this.loadingText.resolution = 2;
    this.preloaderContainer.addChild(this.loadingText);

    this.resizeListener = this.onResize.bind(this);
    this.storeChangeListener = this.onGameStoreChange.bind(this);

    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);
    GameStore.addChangeListener(this.storeChangeListener);
    this.positionGraphics();
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.preloaderContainer.x = (window.innerWidth / 2) - (this.loadingText.width / 2);
    this.preloaderContainer.y = (window.innerHeight / 2) - (this.loadingText.height / 2);
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Called when a CHANGE event is emitted from the GameStore
   * @returns {undefined} undefined
   */
  onGameStoreChange() {
    const state = GameStore.getState();

    this.destroy();

    if (state.mainAssetsLoaded) {
      router.navigate('start');
    }
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);

    GameStore.removeChangeListener(this.storeChangeListener);
    renderHelper.stage.removeChild(this.preloaderContainer);
  },
};

export default preloaderView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/preloader.js
 **/